import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { Response } from 'services/api/types'

type Installment = {
  paymentTermId: any
  entry: string
  total: string
}

type InstallmentResponse = {
  days: number
  dueDate: string
  value: number
}

export const loadOrderInstallments = (
  params: Installment
): Response<InstallmentResponse[]> => {
  return axios.get(`/orders/installment`, {
    params
  })
}

export function useLoadOrderInstallments(params: Installment) {
  return useQuery(
    ['orderInstallments', params],
    () => loadOrderInstallments(params),
    {
      enabled: Number(params.total) > 0 && !!params?.paymentTermId,
      onError: () =>
        toast.error('Não foi possível carregar as parcelas!', {
          toastId: 'orderInstallments'
        })
    }
  )
}
